// SPDX-License-Identifier: AGPL-3.0-or-later

import KonvoClickUpInbox from '@app/features/konvo_notifications/state/KonvoClickUpInbox';
import KonvoWhatsApp from '@app/features/konvo_whatsapp/state/KonvoWhatsApp';
import Messages from '@app/features/messaging/state/MessagingMessages';

export function handleResumed(): void {
	Messages.handleResumed();
	// KONVO: WhatsApp events that fell in the gap are not replayed by the bridge.
	void KonvoWhatsApp.resync();
	// KONVO: nor are ClickUp inbox updates.
	KonvoClickUpInbox.handleReconnect();
}
